export default {
    slug: 'queue',
    title: 'Job Logs',
    visible: [
        'status',
        'job_class',
        'master_user.full_name',
        'sub_jobs_count',
        'succeeded_sub_jobs_count',
        'failed_sub_jobs_count',
        'meta_data',
        'scheduled_at',
        'finished_at',
    ],
    listview: 'JobLogsListView',
    locales: ['common'],
    columns: [],
    actions: {},
    copyColumns: [
        'meta_data'
    ],
    tooltipColumns: [
        'meta_data'
    ],
    templates: {
        meta_data(row, col, store) {
            const data = JSON.parse(row.meta_data);
            const rows = [];
            if (data.error) {
                rows.push({
                    label: 'Error',
                    value: data.error
                })
            }

            if (rows.length === 0) {
                return '';
            }

            let out = '<ul>';
            _.map(rows, (row) => {
                out += `<li><strong>${row.label}: </strong>${row.value}</li>`;
            })
            out += '</ul>';

            return out;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/queue/state.js